import React from "react";
import { Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import logo from "../../assets/logo.jpg";
import CustomButton from "../custom-button/CustomButton";
import CustomDialog from "../custom-dialog/CustomDialog";
import ContactDetails from "./ContactDetails";
import { useState } from "react";

const FirstSection: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  
  const [openContactDetails, setOpenContactDetails] = useState(false);
  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: "100vh",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: isMobile ? "0.5rem" : "1rem",
        overflow: "hidden",
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          mb: { xs: "5rem", md: "10rem" },
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Box pt={isMobile ? 4 : 8} pb={isMobile ? 3 : 6} width="100%">
          <img
            src={logo}
            alt="Logo"
            style={{
              width: "auto",
              height: isMobile ? "10rem" : isDesktop ? "18rem" : "15rem",
              marginTop: "0.625rem",
              maxWidth: "100%",
            }}
          />
          <Typography
            variant="h6"
            color="textSecondary"
            paragraph
            sx={{
              fontSize: { 
                xs: "0.875rem", 
                sm: "1.125rem", 
                md: "1.25rem",
                lg: "1.4rem" 
              },
              overflowWrap: "break-word",
              mt: 3,
              mb: 4,
              px: { xs: 1, md: 0 },
              maxWidth: { lg: "80%" },
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            MK Renovation to profesjonalna firma specjalizująca się w
            kompleksowych usługach czyszczenia i renowacji zewnętrznych
            powierzchni budynków. Oferujemy skuteczne czyszczenie elewacji,
            dachów oraz kostki brukowej, zapewniając im długotrwały, estetyczny
            wygląd. Nasze usługi obejmują również malowanie elewacji, które
            nadaje budynkom świeży, nowoczesny wygląd i dodatkową ochronę przed
            warunkami atmosferycznymi. Dzięki zaawansowanym technologiom oraz
            doświadczonemu zespołowi, MK RENOVATION gwarantuje wysoką jakość
            usług, bezpieczeństwo oraz zadowolenie klientów. Zaufaj
            profesjonalistom i odśwież wygląd swojego domu z MK Renovation!
          </Typography>
          <CustomButton text="Poproś o wycenę" onClick={() => setOpenContactDetails(true)} />
        </Box>
        <CustomDialog
        open={openContactDetails}
        onClose={() => setOpenContactDetails(false)}
        title="Dane Kontaktowe"
        body={<ContactDetails />}
      />
      </Container>
    </Container>
  );
};

export default FirstSection;
